<template>
  <router-view></router-view>
</template>

<script>

import {useSimplepharmAuthModule} from "@/state/pinia/simplepharmAuthModule";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";
import {useUserProfileModule} from "@/state/pinia/userProfileModule";
import {log} from "@/state/pinia/log";
import {isTokenCloseToExpiry} from "@/helpers/authservice/simplepharmUserService";

export default {
  name: 'App',
  components: {},
  computed: {
    simplepharmAuth() {
      return useSimplepharmAuthModule();
    },
    commonModule() {
      return useCommonAppModule();
    },
    lazyloaderModule() {
      return useLazyLoaderModule();
    },
    profileStore() {
      return useUserProfileModule();
    }
  },
  data(){
    return {
      tokenCheckInterval: null,
    }
  },
  methods: {},
  watch: {
    'simplepharmAuth.user': {
      immediate: true,
      handler(newUser) {
        if (newUser && newUser.user) {
          this.profileStore.httpFetchMyProfile();
        }
      }
    }
  },

  mounted() {
    // Set an interval to periodically check the token expiration
    this.tokenCheckInterval = setInterval(() => {
      let user = JSON.parse(localStorage.getItem('user'));
      if (user) {
        const token = user.token;

        if (isTokenCloseToExpiry(token)) {
          // store.dispatch('auth/logout');
          this.$router.push('/logout'); // Redirect to login page
        }
      }

    }, 1000); // Check every 5 minutes
  },
  beforeUnmount() {
    // Clear the interval when component is destroyed
    clearInterval(this.tokenCheckInterval);
  },
  created() {
    // this.simplepharmAuth.refreshToken().then(() => {
      this.commonModule.httpGetLicensedFeatures();
      this.commonModule.httpGetWorkingProfile();
    // });




  }
}
</script>

<style>

.swal-highest{
  z-index: 100100 !important;
}
/* SimplePharm App simple Modal (used mostly to show lazy loader/progress bar dialog, because of b-modal drawbacks) */
.simplepharm-modal {
  display: block; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 100100; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
}

/* Modal Content/Box */
.simplepharm-modal-content {
  background-color: #fefefe;
  margin: 15% auto; /* 15% from the top and centered */
  padding: 20px;
  border: 1px solid #888;
  width: 80%; /* Could be more or less, depending on screen size */
}


.generator-table-container {
  font-family: "Segoe UI", Tahoma, sans-serif;
  font-size: 13px;
  color: #2b2b2b;
  position: absolute;
  top: 124px; /* offset for navbar */
  left: 0;
  width: 100vw;
  display: flex;
  flex-direction: column;
}

.generator-table-container-vertical {
  font-family: "Segoe UI", Tahoma, sans-serif;
  font-size: 13px;
  color: #2b2b2b;
  position: unset;
  top: 8px; /* offset for navbar */
  left: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
}

/* Windows-like breadcrumb/info card styling */
.windows-like-breadcrumb-card {
  background: #ffffff;
  border: 1px solid #e5e7eb; /* light gray border */
  border-radius: 8px;
  padding: 12px 16px;
}

.windows-like-breadcrumb-card .fw-semibold {
  font-weight: 600;
}

.windows-like-breadcrumb-card .btn-light {
  background-color: #f3f4f6;
  border-color: #e5e7eb;
}

.windows-like-breadcrumb-card .btn-light:hover {
  background-color: #e9ecef;
}

.scrollable-container {
  flex: 1 1 auto; /* fill available height of parent */
  overflow: visible;
  max-width: 100%; /* don’t overflow horizontally outside the screen */

  /* Optional: better scrolling behaviour */
  box-sizing: border-box;
}

.admin-section {
  margin: 24px 0 32px;
  padding: 16px;
  background: #ffffff;
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0,0,0,0.04);
}


/* Administration section styling */
.admin-section {
  margin: 24px 0 32px;
  padding: 16px;
  background: #ffffff;
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0,0,0,0.04);
}

.admin-header {
  margin-bottom: 12px;
}

.admin-title-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.admin-title {
  margin: 0;
}

.admin-badge {
  display: inline-block;
  font-size: 12px;
  color: #2457a6;
  background: #e8f0fe;
  padding: 2px 8px;
  border-radius: 12px;
  border: 1px solid #d6e4ff;
}

.admin-description {
  margin: 6px 0 0;
  color: #5f6368;
  font-size: 14px;
}

.admin-actions {
  margin-top: 12px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 12px;
}

.admin-action {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 12px 14px;
  background: #f8fafc;
  color: #0f172a;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease, transform 0.05s ease;
  text-align: left;
}

.admin-action:hover {
  background: #f1f5f9;
  border-color: #cbd5e1;
}

.admin-action:active {
  transform: translateY(1px);
}

.admin-action--primary {
  background: #eef6ff;
  border-color: #cfe1ff;
}

.admin-action--primary:hover {
  background: #e6f0ff;
  border-color: #bcd4ff;
}

.admin-action--danger {
  background: #fff1f2;
  border-color: #fecdd3;
  color: #7f1d1d;
}

.admin-action--danger:hover {
  background: #ffe4e6;
  border-color: #fda4af;
}

.admin-action__icon {
  font-size: 20px;
  line-height: 1;
}

.admin-action__content {
  display: flex;
  flex-direction: column;
}

.admin-action__title {
  font-weight: 600;
}

.admin-action__subtitle {
  font-size: 12px;
  color: #475569;
}

@media (max-width: 600px) {
  .admin-section {
    padding: 12px;
  }
  .admin-actions {
    grid-template-columns: 1fr;
  }
}

</style>
